<div class="background-color"></div>
<div class="background-template"></div>
<div class="center-content">
  <div class="center-div">
    <div class="login-title">
      <div class="title">Mon espace client </div>
      <div class="image"><img [src]="imgLogo" width=300 /></div>
    </div>
    <form [formGroup]="loginForm">
      <div class="mainForm">
        <div class="title-content">Connexion</div>
        <div class="loginSaisieChamps">
          <div class="simpleControl " style="display : none">
            <mat-select placeholder="History">
              <mat-option *ngFor="let historySession of historySessions" (click)="historySelected(historySession)">
                {{historySession.login}}
              </mat-option>
            </mat-select>
          </div>
          <div class="inputChmp">
            <mat-form-field class="form-group ">
              <input matInput placeholder="Nom d'utilisateur" required formControlName="login">
              <mat-error>
                Nom d'utilisateur requis
              </mat-error>
            </mat-form-field>
          </div>
          <!-- <mat-divider class="divider"></mat-divider> -->
          <div class="inputChmp">
            <mat-form-field class="form-group ">
              <input matInput placeholder="Mot de passe" [type]="hide ? 'password' : 'text'" required
                autocomplete="current-password" formControlName="password">
              <mat-error>
                Mot de passe requis
              </mat-error>
              <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <span>
          <button matButton routerLink="/forgot-password">Mot de passe oublié ?</button>
        </span>
        <span style="float: right;">
          <button [disabled]="loading" matButton="filled" class="secondary" (click)="onSubmit()">Login</button>
        </span>
      </div>
    </form>
  </div>
</div>